import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mb-5 text-neutral-700" }
const _hoisted_2 = { class: "text-primary-500" }
const _hoisted_3 = { class: "border-b border-black/[0.04] pb-10 mb-10" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 2,
  class: "flex p-4 mt-5 text-sm bg-primary-50 rounded-2xl space-x-2.5"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/icon/ic-info.svg",
  alt: "icon_info",
  class: "object-contain w-6 h-6"
}, null, -1)
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "pb-10" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-xl font-bold mb-7" }, "Your Appointments", -1)
const _hoisted_10 = { class: "flex flex-wrap items-center justify-between mb-6 space-y-4 lg:space-y-0" }
const _hoisted_11 = { class: "w-full lg:w-[30%]" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "text-xs"
}, "Filter by Booking Type", -1)
const _hoisted_13 = { class: "w-full lg:w-[30%]" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "text-xs"
}, "Filter by Created Date", -1)
const _hoisted_15 = { class: "w-full lg:w-[30%]" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "text-xs"
}, "Filter by Booking Date", -1)
const _hoisted_17 = {
  key: 0,
  class: "grid grid-cols-1 gap-4 lg:grid-cols-3 lg:gap-6"
}
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", null, "No appointments yet.", -1)
const _hoisted_20 = [
  _hoisted_19
]

import PortalLayout from '@/layouts/PortalLayout.vue';
import AppointmentImageCard from '@/components/cards/AppointmentImageCard.vue';
import AppointmentCard from '@/components/cards/AppointmentCard.vue';
import CalendarPicker from "@/components/CalendarPicker.vue";
import MultiselectInput from "@/components/inputs/MultiselectInput.vue";
import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';
import patient from "@/classes/UserData";
import { TabGroup, TabList, Tab } from '@headlessui/vue';
import { useRouter } from 'vue-router';
import { ref, computed, watch, onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const router = useRouter();

const patientData = computed(() => patient.getCurrentUser())

const loader = ref(false)
const showError = ref(false)
const errorMsg = ref(null)
const appointments = ref([]);
const appointmentToday = ref([]);
const appointmentCount = ref(0);
const appointmentStatus = ref([]);
const overview = ref<string>('');

const bookingTypes = [
    { id: '1', label: 'All Appointments', value: 'All' },
    { id: '2', label: 'Individual Appointments', value: 'Individual' },
    { id: '3', label: 'Corporate Appointments', value: 'Corporate' },
    { id: '4', label: 'Soft Booking Appointments', value: 'Soft' },
];

const currentDate = new Date();

const presetDateRange = [
    new Date(currentDate.getFullYear(), 0, 1),
    new Date(currentDate.getFullYear(), 11, 31)
];

const params = ref({
    // Booked, Done, Cancelled/No-Show
    status: 'Booked',
    bookingType: 'All',
    dateRange: presetDateRange,
    createdDateRange: presetDateRange,
    patientId: patientData.value.patient_id
});

const redirectToAppointment = (appointment: object) => {
    if(appointment.booking_type == 'Soft') {
        window.location.assign(`/soft-booking-appointment/show/${appointment.id}`)
    } else {
        window.location.assign(`/appointment/show/${appointment.booking_id}`)
    }
}

const fetchData = () => {
    loader.value = true
    
    patient.getAppointments(params.value)
        .then((result: any) => {
            loader.value = false;
            appointments.value = result.data.appointments;
            appointmentToday.value = result.data.appointmentToday;
            appointmentCount.value = appointmentToday.value.length
            appointmentStatus.value = result.data.appointmentStatus;
        })
        .catch((err) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = err.response.data.message;

            if(err.response.status == 401) {
                window.location.replace('/login');
            }
        })
}

const fetchPatientOverview = () => {
    loader.value = true
    
    patient.fetchPatientOverview()
        .then((result: any) => {
            loader.value = false;
            overview.value = result.data;
        })
        .catch((err) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = err.response.data.message;

            if(err.response.status == 401) {
                window.location.replace('/login');
            }
        })
}

const checkReadStatus = (appointment) => {
    if(appointment.booking_type == 'Soft') {
        return appointmentStatus.value.find(x => x.booking_id == appointment.id).read_at == null;
    } else {
        return appointmentStatus.value.find(x => x.booking_id == appointment.booking_id ? appointment.booking_id : appointment.id).read_at == null;
    }
}

watch(params.value, () => {
    fetchData();
    fetchPatientOverview();
})

onMounted(() => { fetchData() })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PortalLayout, { title: "Your Appointments" }, {
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, [
        _createTextVNode("You have "),
        _createElementVNode("strong", _hoisted_2, _toDisplayString(appointmentCount.value) + " " + _toDisplayString(appointmentCount.value == 1 ? 'Appointment ' : 'Appointments '), 1),
        _createTextVNode("scheduled today")
      ]),
      _createElementVNode("div", _hoisted_3, [
        (appointmentToday.value.length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, " No appointment scheduled for today "))
          : (_openBlock(), _createBlock(AppointmentImageCard, {
              key: 1,
              "appointment-today": appointmentToday.value
            }, null, 8, ["appointment-today"])),
        (overview.value !== '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("p", { innerHTML: overview.value }, null, 8, _hoisted_7)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode(_unref(TabGroup), null, {
          default: _withCtx(() => [
            _createVNode(_unref(TabList), { class: "flex space-x-3 overflow-auto mb-9" }, {
              default: _withCtx(() => [
                _createVNode(_unref(Tab), { as: "template" }, {
                  default: _withCtx(({ selected }) => [
                    _createElementVNode("button", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (params.value.status = 'Booked')),
                      class: _normalizeClass(["py-2 text-sm font-bold transition rounded-full outline-none px-7 ring-0 h-11", selected ? 'bg-primary-500 text-white' : 'bg-zinc-40 text-primary-500 hover:bg-primary-500 hover:text-white'])
                    }, " Upcoming ", 2)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Tab), { as: "template" }, {
                  default: _withCtx(({ selected }) => [
                    _createElementVNode("button", {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (params.value.status = 'Done')),
                      class: _normalizeClass(["py-2 text-sm font-bold transition rounded-full outline-none px-7 ring-0 h-11", selected ? 'bg-primary-500 text-white' : 'bg-zinc-40 text-primary-500 hover:bg-primary-500 hover:text-white'])
                    }, " Completed ", 2)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Tab), { as: "template" }, {
                  default: _withCtx(({ selected }) => [
                    _createElementVNode("button", {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (params.value.status = 'Cancelled/No-Show')),
                      class: _normalizeClass(["py-2 text-sm font-bold transition rounded-full outline-none px-7 ring-0 h-11", selected ? 'bg-primary-500 text-white' : 'bg-zinc-40 text-primary-500 hover:bg-primary-500 hover:text-white'])
                    }, " Cancelled ", 2)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(MultiselectInput, {
                  modelValue: params.value.bookingType,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((params.value.bookingType) = $event)),
                  placeholder: "Show: All Appointments",
                  options: bookingTypes
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(CalendarPicker, {
                  modelValue: params.value.createdDateRange,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((params.value.createdDateRange) = $event)),
                  placeholder: "Filter by Created Date: All",
                  range: "",
                  inline: false
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createVNode(CalendarPicker, {
                  modelValue: params.value.dateRange,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((params.value.dateRange) = $event)),
                  placeholder: "Filter by Booking Date: All",
                  range: "",
                  inline: false
                }, null, 8, ["modelValue"])
              ])
            ]),
            (appointments.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appointments.value, (appointment) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "",
                      key: appointment
                    }, [
                      _createVNode(AppointmentCard, {
                        onClick: ($event: any) => (redirectToAppointment(appointment)),
                        item: appointment,
                        badge: checkReadStatus(appointment)
                      }, null, 8, ["onClick", "item", "badge"])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
          ]),
          _: 1
        })
      ]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Error",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[6] || (_cache[6] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[7] || (_cache[7] = ($event: any) => (showError.value = false))
      }, {
        content: _withCtx(() => [
          _createTextVNode(_toDisplayString(errorMsg.value), 1)
        ]),
        _: 1
      }, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})